import { useBackendSKU } from "~/composables/ttd/useAppFetch";

interface IRequestConfig {
  method: "get" | "head" | "patch" | "post" | "put" | "delete" | "connect" | "options" | "trace";
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
}

export type ResponseType<T> = ReturnType<typeof useBackendFetch<T>>;

export function doRequest<T>(config: IRequestConfig): ResponseType<T> {
  const result = useBackendFetch<T>(config.url, {
    method: config.method,
    body: config.body,
  });
  return result;
}

export function doRequestNoPrefix<T>(config: IRequestConfig): ResponseType<T> {
  // There seem to be 2 backends
  // BFF - backend for frontend
  // /backend/ - some far away backend
  // We are trying to bypass all these options and use a url 
  // to straight call the third backend.
  const result = useBackendSKU<T>(config.url, {
    method: config.method,
    body: config.body,
  });

  return result;
}


